module.exports = __webpack_public_path__ + "img/08.2048ee2a.jpg";